import { auth } from '@/services';

angular.module('app')
    .controller('adminUsersController', adminUsersController);


adminUsersController.$inject = [
    '$httpParamSerializer',
    '$rootScope',
    '$window',
    'alerts',
    'confirmDialog',
    'handleError',
    'industries',
    'queryParams',
    'rolesApi',
    'settings',
    'SettingsApi',
    'thisSiteSettings',
    'UsersApi',
    'Users',
    'Upload',
    'extraParameters',
];

function adminUsersController(
    $httpParamSerializer,
    $rootScope,
    $window,
    alerts,
    confirmDialog,
    handleError,
    industries,
    queryParams,
    rolesApi,
    settings,
    SettingsApi,
    thisSiteSettings,
    UsersApi,
    Users,
    Upload,
    extraParameters,
) {
    const vm = this;
    this.$onInit = $onInit;

    // properties
    vm.industries = angular.copy(industries);
    vm.industries.unshift('All');

    vm.isLoading = false;
    vm.isLoadingFilters = false;
    vm.isLoadingImport = false;
    vm.isLoadingImportMessage = '';
    vm.isLoadingImportProgress = 0;
    vm.sort = 'created_at';
    vm.order = 'desc';
    vm.filters = {
        role_id: null,
        active: '1',
        forumRole: null,
        forename: '',
        surname: '',
        email: '',
        industry: 'All',
        page: 1,
        page_size: 15,
        custom_attrs: {},
    };


    if (extraParameters.userStatus == 'requested') {
        vm.filters.active = 0;
    }

    vm.permissionChecks = {
        canCreateUsers: auth.hasPermission('users.create'),
        canDeleteUsers: auth.hasPermission('users.delete'),
        canEditUsers: auth.hasPermission('users.update'),
        canExportUsers: auth.hasPermission('users.export'),
        canImportUsers: auth.hasPermission('users.import'),
        canManageUserAttributes: auth.hasPermission('sites.set.user_attrs'),
        canViewInactiveUsers: auth.hasPermission('users.view:inactive'),
    };
    vm.roleOptions = [];
    vm.statusOptions = [
        { label: 'Active', value: '1' },
        vm.permissionChecks.canViewInactiveUsers ? { label: 'Inactive', value: '0' } : null,
        { label: 'Requested', value: '-1' },
    ].filter(option => !!option); // filter out "null" items

    // Add expired option only if GDPR expiry threshold is sent
    if (thisSiteSettings.gdpr_settings.reminder.threshold) {
        vm.statusOptions.push({ label: 'Expired', value: 2 });
    }

    vm.forumModeratorOptions = [
        { label: 'Any', value: null },
        { label: 'User', value: '0' },
        { label: 'Moderator', value: '1' },
    ];
    vm.users = {};
    vm.selected = [];
    vm.CSVemail = angular.copy($rootScope.thisUser.email);
    vm.settings = thisSiteSettings;
    vm.userAttrs = thisSiteSettings.user_attrs;
    vm.alwaysRequiredUserAttrs = [
        'email',
    ];
    vm.alwaysEditableUserAttrs = [
      'email',
  ];

    // methods
    vm.getRoles = getRoles;
    vm.getUsers = getUsers;
    vm.editUser = editUser;
    vm.createUser = createUser;
    vm.importUsers = importUsers;
    vm.handleCSV = handleCSV;
    vm.selectUser = selectUser;
    vm.selectAllUsers = selectAllUsers;
    vm.selectNoneUsers = selectNoneUsers;
    vm.toggleSelectAll = toggleSelectAll;
    vm.batchDelete = batchDelete;
    vm.toggleAttributeRequired = toggleAttributeRequired;
    vm.toggleAttributeVisibility = toggleAttributeVisibility;
    vm.toggleAttributeEditable = toggleAttributeEditable;
    vm.toggleAttributePrivacy = toggleAttributePrivacy;
    vm.saveSettings = saveSettings;

    /**
     * Initialises the controller.
     *
     * @returns {void}
     */
    function $onInit(): void {
        vm.getRoles();
        vm.getUsers();

        const matches = $window.location.pathname.match(/admin\/users\/(\d+)/);

        if (matches !== null) {
            vm.editUser(matches[1]);
        }

        /**
         * Sorry, this is nasty but so is Angular and it doesn't like keeping things in sync...
         * Use vm.userAttrs in the template instead of vm.userAttrs
         */
        vm.userAttrsCopy = vm.userAttrs;

        // handle user ID in URL
        if (queryParams.id) {
            Users.edit(queryParams.id);
        }
        if (extraParameters.userId) {
          Users.edit(extraParameters.userId);
        }
    }

    /**
     * Select all users.
     *
     * @return {void}
     */
    function selectAllUsers() {
        vm.selected = vm.users.data.map((user) => {
            return user.id;
        });
    }

    /**
     * Select no users.
     *
     * @return {void}
     */
    function selectNoneUsers() {
        vm.selected = [];
    }

    function toggleSelectAll() {
        if (vm.selected.length) {
            selectNoneUsers();
        } else {
            selectAllUsers();
        }
    }

    /**
     * Delete users in a batch.
     *
     * @return {void}
     */
    function batchDelete() {
        if (vm.selected.length > 0) {
            confirmDialog(`This will delete ${vm.selected.length} user(s). Are you sure?`)
                .result.then((confirm) => {
                    if (confirm) {
                        vm.isLoading = true;

                        UsersApi.batchDelete({
                            'id[]': vm.selected,
                        }, () => {
                            vm.isLoading = false;
                            alerts.emit({
                                theme: 'success',
                                title: 'The user(s) have now been deleted.',
                            });
                            getUsers();
                        }, () => {
                            vm.isLoading = false;
                            alerts.emit({
                                theme: 'error',
                                title: 'There was a problem batch deleting users.',
                            });
                            getUsers();
                        });
                    }
                });
        }
    }

    /**
     * Toggle user selection checkbox.
     *
     * @param  {Number} id
     * @return {void}
     */
    function selectUser(id) {
        if (vm.selected.indexOf(id) !== -1) {
            vm.selected.splice(vm.selected.indexOf(id), 1);
        } else {
            vm.selected.push(id);
        }
    }

    /**
     * Retrieves role filter options from the api and adds them to the scope
     * @return void
     */
    function getRoles() {
        vm.isLoadingFilters = true;
        rolesApi.get((response) => {
            vm.roleOptions = [{ value: null, label: 'Any' }].concat(response.data.map((role) => ({
                value: role.id,
                label: role.label,
            })));
            vm.isLoadingFilters = false;
        }, (err) => {
            handleError(err);
            vm.isLoadingFilters = false;
        });
    }

    /**
     * Retrieves users from the api and adds to scope
     * @return {void}
     */
    function getUsers() {
        vm.selected = [];
        vm.isLoading = true;
        const filters = angular.copy(vm.filters);

        // delete any filters that are empty (API tries to apply them)
        angular.forEach(Object.keys(vm.filters), (filterKey) => {
            if (filters[filterKey] === '' || filters[filterKey] === 'All') {
                delete filters[filterKey];
            }
        });

        // delete any custom attribute filters that are empty (API tries to apply them)
        angular.forEach(Object.keys(filters.custom_attrs), (attrKey) => {
            if (
                !filters.custom_attrs[attrKey]
                || filters.custom_attrs[attrKey] === ''
                || filters.custom_attrs[attrKey] === 'All'
            ) {
                delete filters.custom_attrs[attrKey];
            }
        });

        const active = parseInt(filters.active, 10);
        const forumRole = parseInt(filters.forumRole, 10);
        delete filters.active;
        delete filters.forumRole;

        // Clamps active between -1 and 1 as is_active is a boolean in the backend
        filters.is_active = Math.min(Math.max(active, -1), 1);
        filters.is_forum_mod = (filters.forumRole === null) ? null : forumRole;

        // Filter for expired users if status filter set to 'expired' (filters.active value of 2)
        if (active === 2) {
            const gdprDifference = (thisSiteSettings.gdpr_settings.reminder.threshold).split(' ');
            filters.last_active_at_to = window.moment().subtract(gdprDifference[0], gdprDifference[1])
                .format('YYYY-MM-DD 00:00:00');
        }

        vm.filtersQuery = $httpParamSerializer(filters);

        UsersApi.get(filters, (response) => {
            vm.users = response;
            vm.isLoading = false;
        }, (err) => {
            handleError(err);
            vm.isLoading = false;
        });
    }

    /**
     * Edits the user via a modal, and updates model in this controller
     * @param  {int} userId - ID of user to edit
     * @return {void}
     */
    function editUser(userId) {
        Users.edit(userId)
            .result.then((updatedUser) => {
                // Find and update the user on this page
                angular.forEach(vm.users.data, (user, index) => {
                    if (updatedUser !== undefined && user.id === updatedUser.id) {
                        vm.users.data[index] = updatedUser;
                    }
                });
            }, (action) => {
                if (action === 'deleted') {
                    getUsers();
                }
            });
    }

    /**
     * Creates a user then refreshes data
     * @return {void}
     */
    function createUser() {
        Users.create({ is_active: 1, is_forum_mod: 0, role: 'member' })
            .result.then(() => {
                getUsers();
            });
    }

    /**
     * Assigns CSV file (passed from ng-file-upload directive) to the scope ready for uploading
     * @param  {File} file - Chosen file
     * @return {void}
     */
    function handleCSV(file) {
        if (file) {
            vm.CSVFile = file;
        }
    }

    /**
     * Uploads the chosen CSV file to the server for parsing
     * @return {void}
     */
    function importUsers() {
        if (!vm.CSVFile) {
            return false;
        }

        vm.isLoadingImportMessage = 'Uploading...';
        vm.isLoadingImport = true;
        // upload the image
        Upload.upload({
            url: `${settings.apiBase  }/imports`,
            data: {
                email: vm.CSVEmail,
                csv: vm.CSVFile,
            }
        }).then(() => {
            vm.isLoadingImport = false;
            vm.isLoadingImportProgress = 0;
            $window.location.reload();
        }, () => {
            vm.isLoadingImport = false;
        }, (evt) => {
            const progressPercent = (100 * evt.loaded) / evt.total;
            vm.isLoadingImportProgress = progressPercent;
            if (progressPercent === 100) {
                vm.isLoadingImportProgress = 0;
                vm.isLoadingImportMessage = 'Saving...';
            }
        });
    }

    /**
     * Toggles "visible" value of a user attribute
     * @param  {String} key - attribute key
     * @return {void}
     */
    function toggleAttributeVisibility(key) {
        const attributeIndex = vm.userAttrsCopy.map((attribute) => attribute.key).indexOf(key);
        if (attributeIndex === -1) {
            return false;
        }

        vm.userAttrsCopy[attributeIndex].visible = !vm.userAttrsCopy[attributeIndex].visible;
    }

    /**
     * Adds or removes a toggled attribute in vm.settings.visible_user_attrs
     * @param  {String} key - attribute key
     * @return {void}
     */
    function toggleAttributeRequired(key) {
        const attributeIndex = vm.userAttrsCopy.map((attribute) => attribute.key).indexOf(key);
        if (attributeIndex === -1) {
            return false;
        }

      vm.userAttrsCopy[attributeIndex].editable = true;
      vm.userAttrsCopy[attributeIndex].required = !vm.userAttrsCopy[attributeIndex].required;
    }

    /**
     * Toggles the "editable" value of an attribute in vm.settings.visible_user_attrs
     * @param  {String} key - attribute key
     * @return {void}
     */
    function toggleAttributeEditable(key) {
      const attributeIndex = vm.userAttrsCopy.map((attribute) => attribute.key).indexOf(key);
      if (attributeIndex === -1) {
          return false;
      }
      if (vm.userAttrsCopy[attributeIndex].required && vm.userAttrsCopy[attributeIndex].editable) {
        vm.userAttrsCopy[attributeIndex].required = !vm.userAttrsCopy[attributeIndex].required;
        vm.userAttrsCopy[attributeIndex].editable = !vm.userAttrsCopy[attributeIndex].editable;
      } else {
        vm.userAttrsCopy[attributeIndex].editable = !vm.userAttrsCopy[attributeIndex].editable;
      }
  }

    /**
     * Toggles the "private" value of an attribute in vm.settings.visible_user_attrs
     * @param  {String} key - attribute key
     * @return {void}
     */
    function toggleAttributePrivacy(key) {
        const attributeIndex = vm.userAttrsCopy.map((attribute) => attribute.key).indexOf(key);
        if (attributeIndex === -1) {
            return false;
        }

        vm.userAttrsCopy[attributeIndex].private = !vm.userAttrsCopy[attributeIndex].private;
    }

    /**
     * Save site settings.
     *
     * @param {void}
     * @return {void}
     */
    function saveSettings() {
        const data = angular.copy(vm.settings);
        data.user_attrs = generateAttrKeys(vm.userAttrsCopy);

        SettingsApi.save({ settings: data }, handleSuccess, (resp) => {
            vm.formErrors = resp.data;
        }).suppressValidationAlerts();

        function handleSuccess() {
            alerts.emit({
                theme: 'success',
                title: 'Settings Saved',
                messages: [],
            });
        }
    }

    /**
     * Generates safe attribute keys from the labels
     *
     * @param {Object} attributes - attribute data
     * @return {Object}
     */
    function generateAttrKeys(attributes) {
        attributes.map((obj) => {
            if (obj.custom === true && !obj.key) {

                // generate 'safe' key - alphanumeric
                let safeKey = obj.label.replace(/\W/g, '').toLowerCase();
                const attrKeys = [];

                // grab array of existing attrs to check against
                for (let i = 0; i < attributes.length; i += 1) {
                    attrKeys.push(attributes[i].key);
                }

                // if safe key spotted in attr array
                if (attrKeys.indexOf(safeKey) >= 0) {
                    let newSafeKey = safeKey;
                    let counter = 1;

                    while (attrKeys.indexOf(newSafeKey) >= 0) {
                        // if last character is a number
                        // need to check this, otherwise it just adds another '1' and passes
                        if (parseInt(newSafeKey.substr(-1), 10)) {
                            // get last counter of attr key, increment and test again until pass
                            counter = parseInt(newSafeKey.substr(-1), 10);
                            counter += 1;
                            newSafeKey = newSafeKey.substr(0, newSafeKey.length - 1)
                                + counter.toString();
                        } else {
                            newSafeKey = safeKey.concat(counter.toString());
                        }
                    }

                    safeKey = newSafeKey;
                }

                // add safe key to attr data
                obj.key = safeKey;
            }
        });

        return attributes;
    }
}
